import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { ClientQuestionnairesApiController } from './api-controllers/client-questionnaires.api-controller';
import { ClientQuestionnaireStore } from './stores/client-questionnaire.store';
import {
  Quebec2022TaxFormComponent,
} from './components/quebec-2022-tax-questionnaire/quebec-2022-tax-form/quebec-2022-tax-form.component';
import {
  WarningClientQuestionnaireAlreadySubmittedComponent,
} from './components/warning-client-questionnaire-already-submitted/warning-client-questionnaire-already-submitted.component';
import { CommonModule } from '@angular/common';
import { ClientQuestionnaireEditingGuard } from './guards/client-questionnaire-editing.guard';
import { DiscardChangesComponent } from './components/discard-changes/discard-changes.component';
import {
  ClientQuestionnaireBase,
} from './components/base-client-questionnaire/form/base-form/client-questionnaire.base';
import {
  ClientQuestionnaireBaseFactory,
} from './components/base-client-questionnaire/form/base-form/client-questionnaire-base.factory';
import { GetQuestionnaireComponent } from './pages/get-questionnaire/get-questionnaire.component';
import {
  Quebec2022TaxQuestionnaireChildComponent,
} from './components/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire-child/quebec-2022-tax-questionnaire-child.component';
import {
  Quebec2022TaxFormFactory,
} from './components/quebec-2022-tax-questionnaire/quebec-2022-tax-form/quebec-2022-tax-form.factory';
import {
  ClientQuestionnairesClientPortalApiController,
} from './api-controllers/client-questionnaires.client-portal.api-controller';
import {
  Quebec2022TaxQuestionnaireComponent,
} from './components/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire.component';
import {
  Quebec2022TaxFormResultFactory,
} from './components/quebec-2022-tax-questionnaire/result/quebec-2022-tax-form-result/quebec-2022-tax-form-result.factory';
import {
  ClientQuestionnaireResultBaseFactory,
} from './components/base-client-questionnaire/form/base-result/client-questionnaire-result-base.factory';
import {
  ClientQuestionnaireResultBase,
} from './components/base-client-questionnaire/form/base-result/client-questionnaire-result.base';
import {
  WarningClientQuestionnaireContainsErrorsComponent,
} from './components/warning-client-questionnaire-contains-errors/warning-client-questionnaire-contains-errors.component';
import {
  Quebec2023TaxFormComponent,
} from './components/quebec-2023-tax-questionnaire/quebec-2023-tax-form/quebec-2023-tax-form.component';
import {
  Quebec2023TaxQuestionnaireComponent,
} from './components/quebec-2023-tax-questionnaire/quebec-2023-tax-questionnaire/quebec-2023-tax-questionnaire.component';
import {
  Quebec2023TaxQuestionnaireChildComponent,
} from './components/quebec-2023-tax-questionnaire/quebec-2023-tax-questionnaire-child/quebec-2023-tax-questionnaire-child.component';
import {
  Quebec2023TaxFormFactory,
} from './components/quebec-2023-tax-questionnaire/quebec-2023-tax-form/quebec-2023-tax-form.factory';
import {
  Quebec2023TaxFormResultFactory,
} from './components/quebec-2023-tax-questionnaire/result/quebec-2023-tax-form-result/quebec-2023-tax-form-result.factory';
import {
  SalaryDividendTaxQuestionnaireFormComponent,
} from './components/salary-dividend-tax-questionnaire/salary-dividend-tax-questionnaire-form/salary-dividend-tax-questionnaire-form.component';
import {
  SalaryDividendTaxQuestionnaireFormFactory,
} from './components/salary-dividend-tax-questionnaire/salary-dividend-tax-questionnaire-form/salary-dividend-tax-questionnaire-form.factory';
import {
  SalaryDividendTaxQuestionnaireResultFactory,
} from './components/salary-dividend-tax-questionnaire/result/salary-dividend-tax-questionnaire-result.factory';
import { MagienoAdvancedFormsModule } from '@magieno/angular-advanced-forms';

@NgModule({
  declarations: [
    GetQuestionnaireComponent,
    ClientQuestionnaireBase,
    ClientQuestionnaireResultBase,

    Quebec2022TaxFormComponent,
    Quebec2022TaxQuestionnaireComponent,
    Quebec2022TaxQuestionnaireChildComponent,

    Quebec2023TaxFormComponent,
    Quebec2023TaxQuestionnaireComponent,
    Quebec2023TaxQuestionnaireChildComponent,

    SalaryDividendTaxQuestionnaireFormComponent,

    WarningClientQuestionnaireAlreadySubmittedComponent,
    WarningClientQuestionnaireContainsErrorsComponent,
    DiscardChangesComponent,
  ],
  imports: [
      CommonModule,
      RouterModule,
      CoreModule,
      MagienoAdvancedFormsModule,
  ],
  providers: [
    ClientQuestionnaireStore,
    ClientQuestionnairesApiController,
    ClientQuestionnairesClientPortalApiController,

    ClientQuestionnaireEditingGuard,

    ClientQuestionnaireBaseFactory,
    ClientQuestionnaireResultBaseFactory,
    Quebec2022TaxFormFactory,
    Quebec2022TaxFormResultFactory,

    Quebec2023TaxFormFactory,
    Quebec2023TaxFormResultFactory,

    SalaryDividendTaxQuestionnaireFormFactory,
    SalaryDividendTaxQuestionnaireResultFactory,
  ],
  exports: [
    GetQuestionnaireComponent,
    ClientQuestionnaireBase,
    ClientQuestionnaireResultBase,

    Quebec2022TaxFormComponent,
    Quebec2022TaxQuestionnaireComponent,
    Quebec2022TaxQuestionnaireChildComponent,

    Quebec2023TaxFormComponent,
    Quebec2023TaxQuestionnaireComponent,
    Quebec2023TaxQuestionnaireChildComponent,

    SalaryDividendTaxQuestionnaireFormComponent,

    WarningClientQuestionnaireAlreadySubmittedComponent,
    WarningClientQuestionnaireContainsErrorsComponent,
    DiscardChangesComponent,
  ],
})
export class QuestionnairesModule {
}